import {GenericService, ResultType} from '@/shared/xhttp';
import {Approvisionnement} from '@/models';

export class ApprovisionnementService extends GenericService<Approvisionnement> {

	public getTotauxApprovisionnements(totalParBoisType: boolean, totalParLongueur: boolean, totalDateDebut: string, totalDateFin: string): Promise<ResultType<Approvisionnement>> {
		return super.getC(`/totaux-ventes/${totalParBoisType ? 1 : 0 }/${totalParLongueur ? 1 : 0 }/${totalDateDebut}/${totalDateFin}`, 10000);
	}
}
